import { createContext, Dispatch, SetStateAction } from 'react';

import { EmptyResults, SearchResults } from '@gn-audio/jss-core';

export interface ISearchContext {
  searchResults: SearchResults | EmptyResults;
  setSearchResults: Dispatch<SetStateAction<SearchResults | EmptyResults>>;
}

export const SearchContext = createContext<ISearchContext>({
  setSearchResults: () => {},
  searchResults: { count: 0, items: [] },
});
